import React from 'react';
import { Box, Typography } from '../../../design-system';
import { colors } from '../../../design-system/colors';

interface TabErrorStateProps {
  message: string;
}

/**
 * Error state display for tab content
 */
const TabErrorState: React.FC<TabErrorStateProps> = ({ message }): JSX.Element => (
  <Box
    sx={{
      backgroundColor: colors.card.contentBackground,
      borderRadius: '16px',
      padding: '32px',
      minHeight: '400px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Typography variant="body" color="white" sx={{ opacity: 0.7 }}>
      {message}
    </Typography>
  </Box>
);

export default TabErrorState;
